import React, { useMemo, useState } from "react";

import ACTable from "ac-components/ACTable/ACTable";

import "../ac-components/ac-copy-content-cell/ACCopyContentCell.less";
import CopyIcon from "./ac-icons/CopyIcon";

interface FindingVariablesTableProps {
  fields: string[];
  fieldsDescription: Record<string, string>;
}
const FindingVariablesTable: React.FC<FindingVariablesTableProps> = ({
  fields,
  fieldsDescription,
}) => {
  const [copiedRowKey, setCopiedRowKey] = useState<string | null>(null);

  const handleCopy = (variable: string, key: string) => {
    const textToCopy = `$\{${variable}}`;
    navigator.clipboard.writeText(textToCopy);
    setCopiedRowKey(key);
    setTimeout(() => setCopiedRowKey(null), 2500);
  };

  const dataSource = useMemo(() => {
    return fields.map((field, index) => ({
      key: index.toString(),
      variable: field,
      findingField: fieldsDescription[field] || field,
    }));
  }, [fields, fieldsDescription]);
  const columns = useMemo(
    () => [
      {
        title: "Finding Fields",
        dataIndex: "findingField",
        key: "findingField",
        width: 100,
      },
      {
        title: "Variable",
        dataIndex: "variable",
        key: "variable",
        width: 100,
        render: (
          value: string,
          record: { key: string; variable: string; findingField: string },
        ) => (
          <div className="ac-copy-content-cell-container ac-copy-content-cell-and-copy">
            <div className="ac-copy-content-cell-component">
              {`$\{${value}}`}
            </div>
            <div className="ac-copy-content-icon-wrapper">
              {copiedRowKey === record.key ? (
                <span className="ac-copied-text">Copied!</span>
              ) : (
                <CopyIcon className="ac-copy-content-icon-button" />
              )}
            </div>
          </div>
        ),
      },
    ],
    [copiedRowKey],
  );

  const onRow = (record: { variable: string; key: string }) => {
    return {
      onClick: () => handleCopy(record.variable, record.key),
    };
  };

  return (
    <ACTable
      columns={columns}
      dataSource={dataSource}
      pagination={false}
      rowClassName={"finding-fields-row"}
      onRow={onRow}
    />
  );
};
export default FindingVariablesTable;
